import React, { Component, useState } from 'react';
import toastr from 'toastr';
import * as Define from '../constants/Define';
import * as Validate from './validation';
import routes from '../routers';
import i18n from "../constants/initLng";
import $ from 'jquery';
import queryString from "query-string";
import { message, notification } from 'antd';
import { get, merge, round } from 'lodash';
import { LocalStorage } from '../utils';
import CONFIG from 'constants/Config';

export const downloadFile = (data, filename, blobOptions) => {
    const url = window.URL.createObjectURL(new Blob([data], blobOptions));
    const newLink = document.createElement('a');
    newLink.href = url;
    newLink.setAttribute('download', filename); //or any other extension
    document.body.appendChild(newLink);
    newLink.click();
    window.URL.revokeObjectURL(url);
    newLink.remove();
    return "ok";
};

export const checkParamSort = (valueFilter, stateParamsSort) => {
    let val = removeObjectNull(valueFilter);
    let paramsSort = removeObjectNull(stateParamsSort);
    paramsSort = { ...paramsSort, ...val };
    return paramsSort;
};

export const removeElementObject = (state, field) => {
    let result = {};
    Object.keys(state).map((i) => {
        if (i !== field) {
            result = merge(result, { [i]: state[i] })
        }
    });
    return result;
};

export const removeArrayElementObject = (state, arrayField) => {
    let result = {};
    if (arrayField) {
        Object.keys(state).map((i) => {
            if (!arrayField.includes(i)) {
                result = { ...result, [i]: state[i] }
            }
        });
    }
    return result;
};

export const removeObjectNull = (state, check = false) => {
    if (state) {
        for (var propName in state) {
            if (state[propName] === null || state[propName] === undefined) {
                delete state[propName];
            }
        }
    }
    return state;
};

export const removeElementNull = (state) => {
    let result = [];
    if (state) {
        Object.keys(state).map((i) => {
            if (state[i]) {
                result.push({ [i]: state[i] });
            }
        });
    }
    return result;
};

export const striptags = (val) => {
    val = val.replace(/(<\/?[\S][^>]*>)|([^a-zA-Z0-9@])/ig, "");
    return val;
};

export const showMoney = (val) => {
    var num = 0;
    if (val === "" || val === 0) {
        num = 0;
    } else {
        if (val.length > 6 && val.length < 10) {
            num = parseInt(val.replace(/,/g, '')).toString().replace(/\B(?=(\d{6})+(?!\d))/g, " ");
            num = num.split(" ")[0] + " Triệu";
        } else if (val.length > 9) {
            num = (parseInt(val.replace(/,/g, '')).toString().replace(/\B(?=(\d{8})+(?!\d))/g, " ")).split(" ")[0].toString().replace(/\B(?=(\d{1})+(?!\d))/g, ",");
            if (num.split(",")[1] > 0) {
                num = num + " Tỷ";
            } else {
                num = num.split(",")[0] + " Tỷ";
            }
        } else {
            num = parseInt(val.replace(/,/g, '')).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    return num;
};

export const formatMoney = (val, isInteger = true) => {
    const parseNumber = (value) => {
        if (isInteger) {
            return round(parseFloat(value))
        }
        return Number(value)
    }
    let num = 0;
    let oldVal = val ? val.toString() : "";
    if (oldVal === "" || oldVal === 0) {
        num = 0;
    } else {
        const numArr = oldVal.toString().split('.');
        if (numArr.length > 1) {
            oldVal = numArr[0] + '.' + numArr[1];
        }
        num = isNaN(parseNumber(oldVal.replace(/,/g, '')).toString()) ? 0 : parseNumber(oldVal.replace(/,/g, ''));
        // num = parseInt(oldVal.replace(/,/g, ''));
        num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    }
    // let newVal = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num;
};

export const formatNumber = (val, isInteger = true) => {
    const parseNumber = (value) => {
        if (isInteger) {
            return parseInt(value)
        }
        return Number(value)
    }
    let num = 0;
    let oldVal = val ? val.toString() : "";

    if (oldVal === "" || oldVal === 0) {
        num = 0;
    } else {
        const numArr = oldVal.toString().split('.');
        if (numArr.length > 1) {
            oldVal = numArr[0] + '.' + numArr[1];
        }
        num = isNaN(parseNumber(oldVal.replace(/,/g, '')).toString()) ? 0 : parseNumber(oldVal.replace(/,/g, ''));
        // num = parseInt(oldVal.replace(/,/g, ''));
        // num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "");
        num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "");

    }
    // let newVal = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "");
    return num;
};

export const formatRoomType = (val, isInteger = true) => {
    const parseNumber = (value) => {
        if (isInteger) {
            return parseInt(value)
        }
        return Number(value)
    }
    let num = 0;
    let oldVal = val ? val.toString() : "";

    if (oldVal === "" || oldVal == 0) {
        num = 1;
    } else {
        const numArr = oldVal.toString().split('.');
        if (numArr.length > 1) {
            oldVal = numArr[0] + '.' + numArr[1];
        }
        num = isNaN(parseNumber(oldVal.replace(/,/g, '')).toString()) ? 0 : parseNumber(oldVal.replace(/,/g, ''));
        num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "");

    }

    return num;
};

export const formatPhone = (val) => {
    let num = 0;
    let oldVal = val ? val.toString() : "";
    if (oldVal === "" || oldVal === 0) {
        num = 0;
    } else {
        num = oldVal.toString().replace(/([\D])/g, "");
    }
    return num;
};

export const formatUrlSlug = (value) => {
    return (value || '').replace(/[^\w-]+/g, '').toLowerCase();
};

export const formatImageUrlSlug = (value) => {
    return (value || '').replace(/[^\w-]+/g, '');
};

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
export function lowerizeFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
};

export const getTimeStamp = (plusDay = 0) => {
    var newDay = new Date();
    newDay.setDate(newDay.getDate() + plusDay);
    // const date = new Date();
    const year = newDay.getFullYear();
    let month = newDay.getMonth() + 1;
    if (month < 10) {
        month = '0' + month;
    }
    let day = newDay.getDate();
    if (day < 10) {
        day = '0' + day;
    }
    let hour = newDay.getHours();
    if (hour < 10) {
        hour = '0' + hour;
    }
    let minute = newDay.getMinutes();
    if (minute < 10) {
        minute = '0' + minute;
    }
    let second = newDay.getSeconds();
    if (second < 10) {
        second = '0' + second;
    }
    return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
};

export const convertTime = (ms) => {
    var d, h, m, s;
    s = Math.floor(ms / 1000);
    m = Math.floor(s / 60);
    s = s % 60;
    h = Math.floor(m / 60);
    m = m % 60;
    d = Math.floor(h / 24);
    h = h % 24;
    return `${d} - Ngày : ${h} - Giờ : ${m} - Phút : ${s} - Giây`;
};

export const sleepFunction = ms => new Promise(resolve => setTimeout(resolve, ms));

let timer;
export const lastRequest = ms => new Promise(resolve => {
    clearTimeout(timer);
    timer = setTimeout(resolve, ms);
});

export const validateProduct = (val) => {
    var arr = {
        'name': "Tên sản phẩm",
        'slug': "Tên sản phẩm",
        'cat_id': "Danh mục",
        'supplier_id': "Nhà quản lý",
        'staff_id': "Nhân viên",
    };
    var find = "";
    Object.keys(arr).filter(i => {
        if (i === val) {
            find = arr[i]
        }
        ;
    });
    return find;
};

export const alertMessage = (title, messages, error = false) => {
    toastr.options.progressBar = true;
    toastr.options.closeButton = true;
    toastr.options.preventDuplicates = true;
    let messageError = [];
    if (error) {
        if (typeof messages === "object") {
            Object.keys(messages).map((i) => {
                (messages[i] || []).map((item) => {
                    validateProduct(i) !== "" ? messageError.push('<b>' + validateProduct(i) + '</b> : ' + item + '<br />') : messageError.push(item + '<br />')
                });
            });
        } else {
            messageError = messages;
        }
        toastr.error(messageError, title);
    } else {
        toastr.success(messages, title);
    }
};

export const messageValidator = (check, field, message) => {
    let result;
    if (check) {
        result = {
            [field]: {
                classError: "hms-error-form",
                messageError: message,
            }
        }
    } else {
        result = {};
    }
    return result;
};

export const checkValidate = (data, state, arrayValidate, valueCheck, valueValidate) => {
    let validate = state;
    let result;
    if (Object.keys(arrayValidate).length > 0) {
        Object.keys(arrayValidate).map(i => (
            validate = {
                ...validate,
                [i]: messageValidator(Validate[valueCheck](data[i] ? data[i] : "", valueValidate && valueValidate[i]), i, arrayValidate[i])[i]
            }
        ));
    }
    Object.keys(validate).filter(i => {
        if ((validate[i] && Object.keys(arrayValidate).includes(i))) {
            result = { ...result, [i]: validate[i] }
        }
    });
    return result ? result : {};
};

export const multipleValidate = (data, ruleCheck, maxmin, isList = false) => {
    $(".form-control").removeClass('isValidation');
    $(".form-control input").removeClass('isValidation');
    $(".hms-form-control > div").removeClass('isValidation');
    if (ruleCheck) {
        let resultCheck = {};
        Object.keys(ruleCheck).map(i => {
            return Object.keys(checkValidate(data, data, ruleCheck[i], i)).length > 0 && (
                resultCheck = checkValidate(data, data, ruleCheck[i], i)
            )
        });
        if (maxmin) {
            Object.keys(ruleCheck).map(i => Object.keys(checkValidate(data, data, ruleCheck[i], i, maxmin[i])).length > 0 && (
                resultCheck = Object.assign(resultCheck, checkValidate(data, data, ruleCheck[i], i, maxmin[i]))
            ));
            // return resultCheck;
        }
        if (Object.keys(resultCheck).length > 0) {
            Object.keys(resultCheck).map(i => {
                if(!isList) {
                    $("input[name=" + i + "]").addClass('isValidation');
                    $("select[name=" + i + "]").addClass('isValidation');
                    $("." + i + " > div").addClass('isValidation');
                }
            })
        }
        return resultCheck;
    } else {
        return {};
    }
};

export const reloadValidation = (validation, field) => {
    let result = {};
    Object.keys(validation).map((i) => {
        if (i !== field) {
            $("input[name=" + i + "]").addClass('isValidation');
            $("select[name=" + i + "]").addClass('isValidation');
            $("." + i + " > div").addClass('isValidation');
            result = { ...result, [i]: validation[i] }
        } else {
            $("input[name=" + i + "]").removeClass('isValidation');
            $("select[name=" + i + "]").removeClass('isValidation');
            $("." + i + " > div").removeClass("isValidation");
        }
    });
    return result;
};

export const classValidation = (data, validation, tag) => {
    if (tag) {
        if (Validate[tag](data && data) || validation) {
            return 'hms-error-form';
        } else {
            return "";
        }
    } else {
        return "";
    }

};

export const convertUTCDateToLocalDate = (date) => {
    let newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    return newDate;
};

export const formatShowDate = (date) => {
    return convertUTCDateToLocalDate(new Date(date)).toLocaleDateString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }).split(',')[1]
};

export const formatShowDateTime = (date) => {
    return convertUTCDateToLocalDate(new Date(date)).toLocaleDateString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }).split(',')[1] + " " + convertUTCDateToLocalDate(new Date(date)).toLocaleDateString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }).split(',')[0];
};

export const formatShowDateTimeNonConvert = (date) => {
    return (new Date(date)).toLocaleDateString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }).split(',')[1] + " " + (new Date(date)).toLocaleDateString('vi-VN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
    }).split(',')[0];
};

export const findParentRoute = (groupName, props, objReplace = {}) => {
    let url = props.match.path;
    let itemRoute = FindIteminArrayRecursive(routes, url);
    let pushUrl = "";
    routes.map(i => {
        if (itemRoute.item?.tagSub) {
            if (i?.tagSub === itemRoute.item?.tagSub) {
                i.children && i.children.length > 0 && i.children.map(i2 => {
                    if (i2.group === itemRoute.item.group) {
                        pushUrl = i2.path
                    }
                })
            }
        } else {
            if (i.group === groupName) {
                pushUrl = i.path
            }
        }
    });
    // ADD param parent
    Object.keys(objReplace || {}).forEach(key => {
        pushUrl = pushUrl.replace(key, objReplace[key]);
    })
    return props.history.push(pushUrl);
};

export const getValueForm = (e) => {
    let target = e.target;
    let name;
    let value;
    let newVal;
    if (e.target) {
        name = target.name;
        value = target.value;
        if (target.type === "checkbox") {
            value = target.checked
        }
    } else {
        name = e.name;
        value = e.value;
    }
    newVal = { name: name, value: typeof value === 'string' ? value.trimLeft() : value };
    return newVal;
};

export const checkUndefine = (val, isNumber = false, isByPassZero = false) => {
    return val && (!isNumber || val !== '0') ? val : isByPassZero && val === 0 && !isNumber ? 0 : null;
};

export const columnsTable = (props) => {
    let obj = [];
    if (Object.keys(props).length > 0) {
        if (props.titleTable.length > 0) {
            props.titleTable.map((i, k) => {
                if (props.component && props.component[i]) {
                    // let className = props.component[i].className || '';
                    // if(props.component[i].visible === false){
                    //     className = className + ' hide';
                    // } else {
                    //     className = className.replace(' hide', '');
                    // }
                    obj.push({
                        title: i18n.t(`item.${props.itemName}.${i}`),
                        dataIndex: i,
                        key: k,
                        ...props.component[i],
                        // className: className || undefined,
                    })
                } else {
                    obj.push({
                        title: i18n.t(`item.${props.itemName}.${i}`),
                        dataIndex: i,
                        key: k,
                    })
                }
            });
        }
    }
    return obj;
};
export const columnsTableName = (props) => {
    let obj = [];
    if (Object.keys(props).length > 0) {
        if (props.titleTable.length > 0) {
            props.titleTable.map((i, k) => {
                if (props.component && props.component[i]) {
                    obj.push({
                        title: i === 'Date' ? i18n.t(`item.${props.itemName}.${i}`): `${i}`,
                        dataIndex: i,
                        key: k,
                        ...props.component[i],
                    })
                    
                } else {
                    obj.push({
                        title: `${i}`,
                        dataIndex: i,
                        key: k,
                    })
                }
            });
        }
    }
    return obj;
};

export const arrayRemoveItem = (array, itemRemove) => {
    return array.filter(function (ele) {
        return ele !== itemRemove;
    });
};

export const getTitleTable = (model, arrayTitle, arrayItemRemove = []) => {
    let newArrayTitle = model.concat(arrayTitle);
    if (arrayItemRemove.length > 0) {
        let titleTable = newArrayTitle;
        arrayItemRemove.map(i => {
            titleTable = titleTable.filter((ele) => ele !== i);
        });
        return titleTable;
    } else {
        return newArrayTitle;
    }
};

export const getDataSource = (data, model) => {
    let dataSource = [];
    let listItemData = {};
    model.map(i => listItemData = { ...listItemData, [i]: "" });
    if (data.length > 0) {
        data.map((i, k) => {
            let itemData;
            Object.keys(listItemData).map(i2 => {
                itemData = { ...itemData, [i2]: i[i2] };
            });
            dataSource.push(itemData)
        })
    }
    return dataSource;
};

export const customOptionSelectHMS = (data, params) => {
    let newData = [];
    if (data && params) {
        data.map((i, k) => {
            let object = {};
            params.map((i2, k) => {
                if (k === 0) {
                    object = { name: i[i2] }
                } else if (k === 1) {
                    object = { ...object, value: i[i2] }
                } else {
                    object = { ...object, [i2]: i[i2] };
                }
            });
            newData.push(object)
        })
    }
    return newData;
};

export const formatValidation = (s, f, isTransform = false) => {
    if (s) {
        return !isTransform ? capitalizeFirstLetter(s.replace('%s', f).toLowerCase()) : s.replace('%s', f)
    }
};

export const convertStringToNumber = (string, name, arrayField = []) => {
    if (arrayField.includes(name)) {
        return formatNumber(string);
    } else {
        return string
    }
};

export const genaratePaginateFilterSort = (pagination, filters, sorter, skipQueryParse = false) => {
    let paramsFilter = skipQueryParse ? filters : queryString.parse(queryString.stringify(filters));
    paramsFilter = Object.keys(paramsFilter).length > 0 ? paramsFilter : undefined;
    let newFilters = {
        pageIndex: pagination ? pagination.current : {},
        pageSize: pagination ? pagination.pageSize : undefined,
        ...paramsFilter,
        OrderBy: sorter.field,
        OrderByDesc: sorter.field ? sorter.order === 'descend' : undefined
    };
    newFilters = removeObjectNull(newFilters);
    return newFilters;
};
export const genarateFilter = (filters, skipQueryParse = false) => {
    let paramsFilter = skipQueryParse ? filters : queryString.parse(queryString.stringify(filters));
    paramsFilter = Object.keys(paramsFilter).length > 0 ? paramsFilter : undefined;
    let newFilters = {
        ...paramsFilter,
    };
    newFilters = removeObjectNull(newFilters);
    return newFilters;
};

function getArrayOfChildren(arr, existingChildren) {
    arr.forEach(o => {
        existingChildren.push(o.path);
        o.children && getArrayOfChildren(o.children, existingChildren);
    });
    return existingChildren;
}
let output = {};
export const FindIteminArrayRecursive = (arr, value) => {
    arr.forEach(o => {
        // let flag = false;
        if (o.path) {
            if (o.path === value) {
                output.item = o;
                output.childs = (o.children && getArrayOfChildren(o.children, [])) || [];
            } else if (o.children && o.children.length) {
                output = FindIteminArrayRecursive(o.children, value);
            }
        }
    });
    return output;
};

export const getPermissionActions = (route) => {
    const profile = LocalStorage.get(Define.CONFIG_LOCAL_STORAGE.PROFILE)
    const permissions = profile && profile.permissions ? profile.permissions : [];
    let actionResult = {
        allowViewWhitelistIp: permissions.includes('whitelistip.view'),
        allowRefund: permissions.includes(`${route}.refund`),
        allowCreateIp: permissions.includes('whitelistip.create'),
        allowDeleteIp: permissions.includes('whitelistip.delete'),
        allowCreate: permissions.includes(`${route}.create`),
        allowUpdate: permissions.includes(`${route}.update`),
        allowDelete: permissions.includes(`${route}.delete`),
        allowApprove: permissions.includes(`${route}.approve`),
        allowResendEmail: permissions.includes(`${route}.resendEmail`),
        allowExportVoucher: permissions.includes(`${route}.exportVoucher`),
        allowSaleOrder: permissions.includes(`${route}.saleOrder`),
        allowUseVoucher: permissions.includes(`${route}.useVoucher`),
        allowUpdatePrice: permissions.includes(`${route}.updatePrice`),
        allowExportFileExcel: permissions.includes(`${route}.export`),
        allowViewDetail: permissions.includes(`${route}.viewDetail`),
        allowView: permissions.includes(`${route}.view`),
        allowChangeStatus: permissions.includes(`${route}.updateItemStatus`),
        allowChangeAccountingStatus: permissions.includes(`${route}.updateaccountantstatus`),
        allowLockItem: permissions.includes(`${route}.lockItem`),
        allowMapSku: permissions.includes(`${route}.mapsku`),
        allowReindex: permissions.includes(`${route}.reindex`),
        allowDeactive: permissions.includes(`${route}.deactive`),
        allowSync: permissions.includes(`${route}.sync`),
        allowUpdateStatus: permissions.includes(`${route}.updateStatus`),
        allowViewBundle: permissions.includes(`${route}.bundleView`),
        allowCreateBundle: permissions.includes(`${route}.bundleCreate`),
        allowUpdateBundle: permissions.includes(`${route}.bundleUpdate`),
        allowRecommit: permissions.includes(`${route}.recommit`),
        allowUpdateActiveByExcel: permissions.includes(`${route}.updateActiveByExcel`),
        allowRedeem: permissions.includes(`${route}.redeem`),
        allowReceiptsPayslipCreate: permissions.includes(`${route}.receiptsPayslipCreate`),
        allowExportExcludeUserInfo: permissions.includes(`${route}.exportExcludeUserInfo`),
        allowConfirm: permissions.includes(`${route}.confirm`),
        allowCancel: permissions.includes(`${route}.cancel`),
        allowCheck: permissions.includes(`${route}.check`),
        allowTopup: permissions.includes(`${route}.topup`),
        allowClearCacheRedis: permissions.includes(`${route}.clear`),
    };
    return actionResult;
};

export const getFilenameFromUrl = (url) => url ? url.split('/').pop().split('#').shift().split('?').shift() : undefined;

export const getPathWithParams = (path = '', params = {}, hash = null) => {
    Object.keys(params).forEach(p => {
        const searchStrParam = `\/:${p}`;
        path = path.replace(searchStrParam, `\/${params[p]}`);
    })
    if(hash){
        path = path.replace(/#.*/, '') + `#${hash}`
    }
    return path;
}

/**
 * Wrapper every saga process async function* to by pass try catch block.
 * @param {function} [saga] - saga process async function*.
 * @param {function} [errorHandle] - error handle async function*.
 */
export function sagaWrapper(saga, errorHandle) {
    return function* (action) {
        try {
            yield saga(action);
        } catch (e) {
            yield errorHandle(e, action)
        }
    };
}

/**
 * Handle displaying errors in saga processes.
 * @param {function} callback - callback async function* after show error message.
 * @param {string} itemStringKey - item string key to get item error message: (Ex: hotel, tour, order, group,...).
 */
export function sagaErrorHandler(callback, itemStringKey, isShowMessage = true, isMessagePriority = false) {
    return function* (e, action) {
        if (isMessagePriority) {
            const content = get(e, 'errors[0].message') || i18n.t('validation.unknowError');
            message.error({ content, key: action.type, duration: 5 });
        } else if (e.status === 403) {
            alertMessage(i18n.t('notifi.title'), i18n.t('notification.youCantAccessThisPage'), true);
        } else if (e.errors) {
            if (get(e, 'errors[0].code') === 'VOUCHER_USED_CANNOT_CHANGE_STATUS') {
                const errMess = yield i18n.t(`validation.statusCode.code.VOUCHER_USED_CANNOT_CHANGE_STATUS`).replace('%s', i18n.t(`item.order.orderStatus.${e.request.status}`))
                message.error({
                    content: errMess,
                    key: action.type, duration: 5
                });
            } else if (get(e, 'errors[0].code') === 'MRU_BUNDLE_RATE_PLAN_EXISTED_OTHER_CAMPAIN' || get(e, 'errors[0].code') === 'REDEEM_COMMIT_FIXEDCHARGE_ERROR') { //not show err
                isShowMessage = false;
            } else if (get(e, 'errors[0].code') === 'TICKET_COMBO_MUST_INCLUDE_DEFAULT_OBJECT_TYPE'){
                const errMess = 'VÉ COMBO PHẢI BAO GỒM LOẠI ĐỐI TƯỢNG CƠ BẢN'
                isShowMessage && message.error({ content: errMess, key: action.type, duration: 5 });
            } else if (get(e, 'errors[0].code') === '07'){
                const errMess = e.errors[0]?.message
                isShowMessage && message.error({ content: errMess, key: action.type, duration: 5 });
            }
            else {
                const code = e.code || e.errors.title || get(e, 'errors[0].code') || 'UNDEFINED_ERROR';
                const itemErrorMess = itemStringKey ? (code && !i18n.t(`item.${itemStringKey}.errorCode.${code}`).endsWith(code)
                    ? i18n.t(`item.${itemStringKey}.errorCode.${code}`) : undefined) : undefined;
                const mess = typeof e.errors === 'string' ? e.errors : i18n.t(`validation.statusCode.code.${code}`);
                if (code === 'INVALID_PRODUCTS'){
                    const content = get(e, 'errors[0].message');
                    isShowMessage && message.error({ content, key: action.type, duration: 5 });
                } else {
                    const content = itemErrorMess || mess || `${i18n.t(`validation.statusCode.code.UNDEFINED_ERROR`)}${code !== 'UNDEFINED_ERROR' ? `: ${code}` : ''}`;
                    isShowMessage && message.error({ content, key: action.type, duration: 5 });
                }
            }
        } else if (e.status) {
            isShowMessage && message.error({ content: i18n.t(`validation.statusCode.code.${e.status}`), key: action.type, duration: 5 });
        } else {
            isShowMessage && message.error({ content: i18n.t(`validation.connectFail`), key: action.type, duration: 5 });
        }
        if (callback) {
            yield callback(e);
        }
    };
}

/**
 * Display success notifications in saga processes
 * @param {Object} [action] - saga action object.
 * @param {string} [message] - message to display.
 * @param {string} description - description to display as sub text bellow the message.
 */
export function sagaSuccessMessage(action, successMessage = null, description = null) {
    if (action && typeof action.message === 'string' && successMessage === null && description === null) {
        successMessage = action.message;
        description = action.description;
        action = action.action;
    }
    return message.success({
        content: (
            <React.Fragment>
                <span>{successMessage}</span>
                {!!description && <React.Fragment>
                    <br /><div style={{ width: '100%', paddingLeft: 25, textAlign: 'left' }}>
                        <span style={{ fontStyle: 'italic', fontSize: 10, opacity: 0.9 }}>{description}</span>
                    </div>
                </React.Fragment>}
            </React.Fragment>
        ),
        key: action ? action.type : undefined,
        duration: 4,
    })
}

/**
 * Display error messages in saga processes
 * @param {Object} error - error object from API or saga.
 * @param {string} errorActionType - action type for error handling.
 * @param {string} [errorTitle] - custom error title, defaults to auto translate error.
 */
export function handleErrorMessage(error, errorActionType, errorTitle = null) {
    const errorMessage = error?.errors?.[0]?.message || error?.message || i18n.t(`validation.statusCode.code.UNDEFINED_ERROR`);
    return message.error({ 
        content: (
            <React.Fragment>
                <span>{errorTitle}</span>
                <React.Fragment>
                    <br /><div style={{ width: '100%', paddingLeft: 25, textAlign: 'left' }}>
                        <span style={{ fontStyle: 'italic', fontSize: 10, opacity: 0.9 }}>{errorMessage}</span>
                    </div>
                </React.Fragment>
            </React.Fragment>
        ), 
        key: errorActionType, 
        duration: 5 
    });
}

/**
 * Display loading notifications in saga processes
 * @param {Object} [action] - saga action object.
 * @param {string} [message] - message to display.
 */
export function sagaLoadingMessage(action, loadingMessage = null, duration = undefined) {
    if (action && typeof action.message === 'string' && loadingMessage === null && duration === undefined) {
        loadingMessage = action.message;
        duration = action.duration
        action = action.action;
    }
    return message.loading({
        content: loadingMessage || i18n.t(`action.loading`),
        key: action ? action.type : undefined,
        duration,
    })
}

export function vietnameseStringToUnicode(vnString) {
    vnString = vnString.replace(/á|à|ả|ạ|ã|ă|ắ|ằ|ẳ|ẵ|ặ|â|ấ|ầ|ẩ|ẫ|ậ/gi, 'a');
    vnString = vnString.replace(/é|è|ẻ|ẽ|ẹ|ê|ế|ề|ể|ễ|ệ/gi, 'e');
    vnString = vnString.replace(/i|í|ì|ỉ|ĩ|ị/gi, 'i');
    vnString = vnString.replace(/ó|ò|ỏ|õ|ọ|ô|ố|ồ|ổ|ỗ|ộ|ơ|ớ|ờ|ở|ỡ|ợ/gi, 'o');
    vnString = vnString.replace(/ú|ù|ủ|ũ|ụ|ư|ứ|ừ|ử|ữ|ự/gi, 'u');
    vnString = vnString.replace(/ý|ỳ|ỷ|ỹ|ỵ/gi, 'y');
    vnString = vnString.replace(/đ/gi, 'd');
    return vnString;
}

export function stringToUrlSlug(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    let slug = str.toLowerCase();
    //Đổi ký tự có dấu thành không dấu
    slug = vietnameseStringToUnicode(slug);
    //Xóa các ký tự đặt biệt
    slug = slug.replace(/\`|\~|\!|\@|\#|\||\$|\%|\^|\&|\*|\(|\)|\+|\=|\,|\.|\/|\?|\>|\<|\'|\"|\:|\;|_/gi, '');
    //Đổi khoảng trắng thành ký tự gạch ngang
    slug = slug.replace(/ /gi, "-");
    //Đổi nhiều ký tự gạch ngang liên tiếp thành 1 ký tự gạch ngang
    //Phòng trường hợp người nhập vào quá nhiều ký tự trắng
    slug = slug.replace(/\-\-\-\-\-/gi, '-');
    slug = slug.replace(/\-\-\-\-/gi, '-');
    slug = slug.replace(/\-\-\-/gi, '-');
    slug = slug.replace(/\-\-/gi, '-');
    //Xóa các ký tự gạch ngang ở đầu và cuối
    slug = '@' + slug + '@';
    slug = slug.replace(/\@\-|\-\@|\@/gi, '');
    return slug.replace(' ', '');
};

export function checkWhiteListURL(url) {
    const pattens = new RegExp(`^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?(${Define.WHITE_LIST_DOMAIN.join('|')})?(\/.*)?$`);
    return pattens.test(url)
}

export const suspressNegativeNumber = (event) => {
    const preventKey = [
        189, // - key
        69 // e / E key
    ];

    if (preventKey.includes(event.keyCode)) {
        event.preventDefault();
        return;
    }
}

export const changeDomainToVPTWeb = () =>{
    const currentDomain = window.location.hostname;
    let vptDomain;
    switch (currentDomain) {
        case Define.LIST_DOMAIN_VPT_ADMIN.dev:
            vptDomain = Define.LIST_DOMAIN_VPT_WEBSITE.dev;
            break;
        case Define.LIST_DOMAIN_VPT_ADMIN.stg:
            vptDomain = Define.LIST_DOMAIN_VPT_WEBSITE.stg;
            break;
        case Define.LIST_DOMAIN_VPT_ADMIN.beta:
            vptDomain = Define.LIST_DOMAIN_VPT_WEBSITE.beta;
            break;
        case Define.LIST_DOMAIN_VPT_ADMIN.prod:
            vptDomain = Define.LIST_DOMAIN_VPT_WEBSITE.prod;
            break;
        default:
            vptDomain = Define.LIST_DOMAIN_VPT_WEBSITE.dev;
            break;
    }    
    return vptDomain;
}
